<div class="animated fadeIn">
    <div class="container-fluid">
        <dx-load-panel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoader" [showIndicator]="true" [showPane]="true" [shading]="true" [closeOnOutsideClick]="false" [message]="messageLoader" height="10%" width="15%"></dx-load-panel>
        <div *ngIf="ad">
            <h3>Persona Jurídica</h3>
            <br>
            <!-- FORMULARIO ADMINISTRADOR DESIGNADO -->
            <form [formGroup]="formAdministradorDesignado">
                <h4>Datos de su empresa</h4>
                <div class="row">
                    <div class="col-md-4">
                        <label for="nit">Nit</label>
                        <input type="text" class="form-control" id="nit" placeholder="nit" formControlName="nitEmpresa" readonly>
                    </div>
                    <div class="col-md-4">
                        <label for="nombreEmpresaA">Nombre empresa</label>
                        <input type="text" class="form-control" id="nombreEmpresaA" placeholder="Nombre Empresa" formControlName="nombreEmpresa" readonly>
                    </div>
                    <div class="col-md-4">
                        <label for="correoElectronicoA">Correo electrónico</label>
                        <input type="text" class="form-control" id="correoElectronicoA" placeholder="Correo Electrónico" formControlName="correoElectronico" readonly>
                    </div>
                </div>
                <br>
                <h4>Asignación contraseña</h4>
                <div class="row">
                    <div class="col-md-6 col-sm-6">
                        <label for="contrasena1">Asigne su contraseña</label>
                        <input type="password" id="contrasena1" class="form-control" formControlName="contrasena1" name="contrasena1" autocomplete="off" (paste)="$event.preventDefault()" (copy)="$event.preventDefault()" placeholder="Digite su nueva contraseña">
                    </div>
                    <div class="col-md-6 col-sm-6">
                        <label for="contrasena2">Repita su contraseña</label>
                        <input type="password" id="contrasena2" class="form-control" formControlName="contrasena2" name="contrasena2" autocomplete="off" (paste)="$event.preventDefault()" (copy)="$event.preventDefault()" placeholder="Repetir contraseña">
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <p *ngIf="formAdministradorDesignado.get('contrasena1').hasError('minlength') && formAdministradorDesignado.get('contrasena1').dirty" class="text-danger">La contraseña es demasiado corta</p>
                        <p *ngIf="formAdministradorDesignado.get('contrasena1').hasError('notnumber') && formAdministradorDesignado.get('contrasena1').dirty" class="text-danger">Su contraseña debe contener al menos un carácter numérico</p>
                        <p *ngIf="formAdministradorDesignado.get('contrasena1').hasError('mayuscula') && formAdministradorDesignado.get('contrasena1').dirty" class="text-danger">Su contraseña debe contener al menos una letra mayúscula</p>
                        <p *ngIf="formAdministradorDesignado.get('contrasena1').hasError('minuscula') && formAdministradorDesignado.get('contrasena1').dirty" class="text-danger">Su contraseña debe contener al menos una letra minúscula</p>
                        <p *ngIf="formAdministradorDesignado.get('contrasena1').hasError('especial') && formAdministradorDesignado.get('contrasena1').dirty" class="text-danger">Su contraseña debe contener al menos un carácter especial</p>
                    </div>
                    <div class="col-md-6">
                        <div>
                            <p *ngIf="formAdministradorDesignado.get('contrasena2').hasError('equalsTo') && formAdministradorDesignado.get('contrasena2').dirty" class="text-danger">
                                Las contraseñas no coinciden
                            </p>
                        </div>
                    </div>
                </div>
                <br>
                <h3>Datos de usuario</h3>
                <div class="row">
                    <div class="col-md-4">
                        <label for="tipoDocumento">Tipo de documento<span class="text-danger">*</span></label>
                        <select name="tipoDocumento" id="tipoDocumento" formControlName="tipoDocumento" class="form-control form-control-lg" disabled>
              <option value="{{item.idAdmCategoria}}" *ngFor="let item of listTypeDocumnet">{{item.nombre}}</option>
            </select>
                    </div>
                    <div class="col-md-4">
                        <label for="numeroDocumentoA">Número documento<span class="text-danger">*</span></label>
                        <input type="text" class="form-control" placeholder="Número Documento" formControlName="numeroDocumento" readonly>
                    </div>

                </div>
                <div class="row">
                    <div class="col-md-4">
                        <label for="nombresA">Nombres<span class="text-danger">*</span></label>
                        <input type="text" class="form-control" placeholder="Nombres" formControlName="nombres" readonly>
                    </div>
                    <div class="col-md-4">
                        <label for="pApellidoA">Primer apellido<span class="text-danger">*</span></label>
                        <input type="text" class="form-control" placeholder="Primer apellido" formControlName="primerApellido" readonly>
                    </div>
                    <div class="col-md-4">
                        <label for="sApellidoA">Segundo apellido</label>
                        <input type="text" class="form-control" placeholder="Segundo apellido" formControlName="segundoApellido" readonly>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <label for="telefonoA">Teléfono<span class="text-danger">*</span></label>
                        <input type="text" class="form-control" placeholder="Teléfono" formControlName="telefono" readonly>
                    </div>
                    <div class="col-md-4">
                        <label for="cargoA">Cargo</label>
                        <input type="text" class="form-control" placeholder="Cargo" formControlName="cargo" readonly>
                    </div>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="checkbox" id="chckTerminosAdministradorAsignado" value="1">
                    <label class="form-check-label text-info" (click)="terminosyCondiciones()" for="chckTerminosAdministradorAsignado"><u>Acepto Términos y Condiciones de Uso del Portal Web</u></label>
                </div>
                <br>
                <div class="row d-flex">
                    <div class="col-md-12 text-right">
                        <button class="btn btn-primary mb-5 mt-5" (click)="openModalAdministradorAsignadoPortalModal()">Registrar</button>
                    </div>
                </div>
                <br>
                <br>
            </form>
        </div>

        <!-- PERSONA JURIDICA -->
        <div *ngIf="rl">
            <h1>Creación de usuarios</h1>
            <h3>Persona Jurídica</h3>
            <br>
            <form [formGroup]="formPersonaJuridica">
                <h4>Datos de su empresa</h4>
                <div class="row">
                    <div class="col-md-4">
                        <label for="nitJ">Nit</label>
                        <input type="text" class="form-control" id="nitJ" placeholder="nit" formControlName="nitEmpresa" readonly>
                    </div>
                    <div class="col-md-4">
                        <label for="nombreEmpresaJ">Nombre empresa</label>
                        <input type="text" class="form-control" id="nombreEmpresaJ" placeholder="Nombre Empresa" formControlName="nombreEmpresa" readonly>
                    </div>
                    <div class="col-md-4">
                        <label for="correoElectronicoJ">Correo electrónico</label>
                        <input type="text" class="form-control" id="correoElectronicoJ" placeholder="Correo Electrónico" formControlName="correoElectronico" readonly>
                    </div>
                </div>
                <br>
                <h4>Asignación contraseña</h4>
                <div class="row">
                    <div class="col-md-6 col-sm-6">
                        <label for="contrasena1">Asigne su contraseña</label>
                        <input type="password" id="contrasena1" class="form-control" formControlName="contrasena1" name="contrasena1" autocomplete="off" (paste)="$event.preventDefault()" (copy)="$event.preventDefault()" placeholder="Digite su nueva contraseña">
                    </div>
                    <div class="col-md-6 col-sm-6">
                        <label for="contrasena2">Repita su contraseña</label>
                        <input type="password" id="contrasena2" class="form-control" formControlName="contrasena2" name="contrasena2" autocomplete="off" (paste)="$event.preventDefault()" (copy)="$event.preventDefault()" placeholder="Repetir contraseña">
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <p *ngIf="formPersonaJuridica.get('contrasena1').hasError('minlength') && formPersonaJuridica.get('contrasena1').dirty" class="text-danger">La contraseña es demasiado corta</p>
                        <p *ngIf="formPersonaJuridica.get('contrasena1').hasError('notnumber') && formPersonaJuridica.get('contrasena1').dirty" class="text-danger">Su contraseña debe contener al menos un carácter numérico</p>
                        <p *ngIf="formPersonaJuridica.get('contrasena1').hasError('mayuscula') && formPersonaJuridica.get('contrasena1').dirty" class="text-danger">Su contraseña debe contener al menos una letra mayúscula</p>
                        <p *ngIf="formPersonaJuridica.get('contrasena1').hasError('minuscula') && formPersonaJuridica.get('contrasena1').dirty" class="text-danger">Su contraseña debe contener al menos una letra minúscula</p>
                        <p *ngIf="formPersonaJuridica.get('contrasena1').hasError('especial') && formPersonaJuridica.get('contrasena1').dirty" class="text-danger">Su contraseña debe contener al menos un carácter especial</p>
                    </div>
                    <div class="col-md-6">
                        <div>
                            <p *ngIf="formPersonaJuridica.get('contrasena2').hasError('equalsTo') && formPersonaJuridica.get('contrasena2').dirty" class="text-danger">
                                Las contraseñas no coinciden
                            </p>
                        </div>
                    </div>
                </div>
                <br>
                <h3>Datos de usuario</h3>
                <div class="row">
                    <div class="col-md-4">
                        <label for="tipoDocumento">Tipo de documento<span class="text-danger">*</span></label>
                        <select name="tipoDocumento" id="tipoDocumento" formControlName="tipoDocumento" class="form-control form-control-lg" disabled>
                  <option value="{{item.idAdmCategoria}}" *ngFor="let item of listTypeDocumnet">{{item.nombre}}</option>
                </select>
                    </div>
                    <div class="col-md-4">
                        <label for="numeroDocumentoJ">Número documento<span class="text-danger">*</span></label>
                        <input type="text" class="form-control" id="numeroDocumentoJ" placeholder="Número Documento" formControlName="numeroDocumento" readonly>
                    </div>

                </div>
                <div class="row">
                    <div class="col-md-4">
                        <label for="nombreJ">Nombre<span class="text-danger">*</span></label>
                        <input type="text" id="nombreJ" class="form-control" placeholder="Nombres" formControlName="nombres" readonly>
                    </div>
                    <div class="col-md-4">
                        <label for="pApellidoJ">Primer apellido<span class="text-danger">*</span></label>
                        <input type="text" id="pApellidoJ" class="form-control" placeholder="Primer apellido" formControlName="primerApellido" readonly>
                    </div>
                    <div class="col-md-4">
                        <label for="sApellidoJ">Segundo apellido</label>
                        <input type="text" id="sApellidoJ" class="form-control" placeholder="Segundo apellido" formControlName="segundoApellido" readonly>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <label for="telefonoJ">Teléfono<span class="text-danger">*</span></label>
                        <input type="text" id="telefonoJ" class="form-control" placeholder="Teléfono" formControlName="telefono" readonly>
                    </div>
                    <div class="col-md-4">
                        <label for="cargoJ">Cargo</label>
                        <input type="text" id="cargoJ" class="form-control" placeholder="Cargo" formControlName="cargo" readonly>
                    </div>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="checkbox" id="chckTerminosJuridica" value="1">
                    <label class="form-check-label  text-info" (click)="terminosyCondiciones()" for="chckTerminosJuridica"><u>Acepto Términos y Condiciones de Uso del Portal Web</u></label>
                </div>
                <br>
                <div class="row d-flex">
                    <div class="col-md-12 text-right">
                        <button class="btn btn-primary mb-5 mt-5" (click)="openAdministradorPortalModal()">Registrar</button>
                    </div>
                </div>
                <br>
                <br>
            </form>
        </div>

        <!-- PERSONA NATURAL -->
        <div *ngIf="nat">
            <h3>Persona Natural</h3>
            <br>
            <form [formGroup]="formPersonaNatural">
                <br>
                <h4>Asignación contraseña</h4>
                <div class="row">
                    <div class="col-md-6 col-sm-6">
                        <label for="contrasena1">Asigne su contraseña</label>
                        <input type="password" id="contrasena1" class="form-control" formControlName="contrasena1" name="contrasena1" autocomplete="off" (paste)="$event.preventDefault()" (copy)="$event.preventDefault()" placeholder="Digite su nueva contraseña">
                    </div>
                    <div class="col-md-6 col-sm-6">
                        <label for="contrasena2">Repita su contraseña</label>
                        <input type="password" id="contrasena2" class="form-control" formControlName="contrasena2" name="contrasena2" autocomplete="off" (paste)="$event.preventDefault()" (copy)="$event.preventDefault()" placeholder="Repetir contraseña">
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <p *ngIf="formPersonaNatural.get('contrasena1').hasError('minlength') && formPersonaNatural.get('contrasena1').dirty" class="text-danger">La contraseña es demasiado corta</p>
                        <p *ngIf="formPersonaNatural.get('contrasena1').hasError('notnumber') && formPersonaNatural.get('contrasena1').dirty" class="text-danger">Su contraseña debe contener al menos un carácter numérico</p>
                        <p *ngIf="formPersonaNatural.get('contrasena1').hasError('mayuscula') && formPersonaNatural.get('contrasena1').dirty" class="text-danger">Su contraseña debe contener al menos una letra mayúscula</p>
                        <p *ngIf="formPersonaNatural.get('contrasena1').hasError('minuscula') && formPersonaNatural.get('contrasena1').dirty" class="text-danger">Su contraseña debe contener al menos una letra minúscula</p>
                        <p *ngIf="formPersonaNatural.get('contrasena1').hasError('especial') && formPersonaNatural.get('contrasena1').dirty" class="text-danger">Su contraseña debe contener al menos un carácter especial</p>
                    </div>
                    <div class="col-md-6">
                        <div>
                            <p *ngIf="formPersonaNatural.get('contrasena2').hasError('equalsTo') && formPersonaNatural.get('contrasena2').dirty" class="text-danger">
                                Las contraseñas no coinciden
                            </p>
                        </div>
                    </div>
                </div>
                <br>
                <h3>Datos de usuario</h3>
                <div class="row">
                    <div class="col-md-4">
                        <label for="tipoDocumento">Tipo de documento<span class="text-danger">*</span></label>
                        <select name="tipoDocumento" id="tipoDocumento" formControlName="tipoDocumento" readonly class="form-control form-control-lg" disabled>
              <option value="{{item.idAdmCategoria}}" *ngFor="let item of listTypeDocumnet">{{item.nombre}}</option>
            </select>
                    </div>
                    <div class="col-md-4">
                        <label for="numeroDocumentoN">Número documento<span class="text-danger">*</span></label>
                        <input type="text" class="form-control" placeholder="Número Documento" formControlName="numeroDocumento" readonly>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <label for="nombresN">Nombres<span class="text-danger">*</span></label>
                        <input type="text" id="nombresN" class="form-control" placeholder="Nombres" formControlName="nombres" readonly>
                    </div>
                    <div class="col-md-4">
                        <label for="pApellidoN">Primer apellido<span class="text-danger">*</span></label>
                        <input type="text" id="pApellidoN" class="form-control" placeholder="Primer apellido" formControlName="primerApellido" readonly>
                    </div>
                    <div class="col-md-4">
                        <label for="sApellidoN">Segundo apellido</label>
                        <input type="text" id="sApellidoN" class="form-control" placeholder="Segundo apellido" formControlName="segundoApellido" readonly>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <label for="telefonoN">Teléfono<span class="text-danger">*</span></label>
                        <input type="text" id="telefonoN" class="form-control" placeholder="Teléfono" formControlName="telefono" readonly>
                    </div>
                    <div class="col-md-4">
                        <label for="correoElectronicoN">Correo electrónico<span class="text-danger">*</span></label>
                        <input type="text" class="form-control" id="correoElectronicoN" placeholder="Correo Electrónico" formControlName="correoElectronico" readonly>
                    </div>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="checkbox" id="chckTerminosNatural" value="1">
                    <label class="form-check-label text-info" (click)="terminosyCondiciones()" for="chckTerminosNatural"><u>Acepto Términos y Condiciones de Uso del Portal Web</u></label>
                </div>
                <br>

                <div class="row d-flex flex-row-reverse">
                    <div class="col-md-12 text-right">
                        <button class="btn btn-primary mb-5 mt-5" (click)="openPersonaNaturalModal()">Registrar</button>
                    </div>
                </div>
                <br>
                <br>
            </form>
        </div>
    </div>
</div>
<!-- /Start modal -->
<div class="modal fade large" tabindex="-1" role="dialog" aria-labelledby="myExtraLargeModalLabel" id="AdministradorPortalModal" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">

            <div class="modal-body">
                <p>
                    Para el uso del Portal Web, WILLIS TOWERS WATSON COLOMBIA CORREDORES DE SEGUROS S.A, asignara un usuario y contraseña que deberá ser custodiado con el mayor cuidado y diligencia por usted, el funcionario que designe como Administrador, así como por aquellos
                    que sean seleccionados y los funcionarios designados como usuarios, conforme los Términos y Condiciones del Portal Web. En su calidad de Representante Legal, deberá designar un funcionario de la compañía, para que desempeñe las funciones
                    de Administrador dentro del Portal Web. Por favor tenga presente que el funcionario designado actuará en nombre y representación propia y tendrá a su cargo las siguientes funciones:
                </p>
                <p>1. Realizar transacciones en nombre de su Compañía, tales como actualización del Formulario de conocimiento de Cliente Sarlaft, generación de reportes, entre otras.</p>
                <p>¿El administrador del portal Web será usted?</p>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="inlineRadioOptions" (change)="SiNoAdmin($event)" id="inlineRadio1" value="Si">
                    <label class="form-check-label" for="inlineRadio1">Si</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="inlineRadioOptions" (change)="SiNoAdmin($event)" id="inlineRadio2" value="No" checked>
                    <label class="form-check-label" for="inlineRadio2">No</label>
                </div>
                <div *ngIf="!siNoAdmin">
                    <label for="emailAdminDesignado">Escriba el correo electrónico del administrador que asignara para el PortalWeb</label>
                    <input type="text" name="emailAdminDesignado" id="emailAdminDesignado" class="form-control">
                </div>
                <div class="text-right">
                    <button class="btn btn-primary my-3" placeholder="Correo Electrónico" (click)="insertarPersonaJuridica()">Enviar Correo</button>
                </div>

            </div>
        </div>
    </div>
</div>
<!-- /End modal -->



<!-- /Start modal ADMINISTRADOR DESIGNADO -->
<div class="modal fade large" tabindex="-1" role="dialog" aria-labelledby="myExtraLargeModalLabel" id="AdministradorAsignado" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">

            <div class="modal-body">
                <p>
                    Usted ha sido designado por el Representante Legal de su Compañía como Administrador del usuario (Responsable Sarlaft) asignado por WILLIS TOWERS WATSON COLOMBIA CORREDORES DE SEGUROS S.A para el uso del Portal Web. Tenga presente que una vez usted empiece
                    a hacer uso del Portal Web se entenderá que acepta y está de acuerdo con los Términos y Condiciones de uso del Portal Web.
                </p>
                <p>Sus funciones como Administrador dentro del Portal Web son las siguientes:</p>
                <p>1. Realizar transacciones en nombre de su Compañía, tales como actualización del Formulario de conocimiento de Cliente Sarlaft, generación de reportes, entre otras.</p>

                <div class="text-right">
                    <button class="btn btn-primary my-3" placeholder="Correo Electrónico" (click)="insertarAdministradorDesignado()">Acepto</button>
                </div>

            </div>
        </div>
    </div>
</div>
<!-- /End modal ADMINISTRADOR DESIGNADO -->

<!-- /Start modal PERSONA NATURAL -->
<div class="modal fade large" tabindex="-1" role="dialog" aria-labelledby="myExtraLargeModalLabel" id="PersonaNaturalModal" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">

            <div class="modal-body">
                <p>
                    Usted ha sido designado como Usuario del Portal Web de WILLIS TOWERS WATSON COLOMBIA CORREDORES DE SEGUROS S.A., por favor al hacer uso del mismo, tenga presente que está actuando en nombre y Representación Propia, y en este sentido en atención a lo anterior
                    la información que sea incluida dentro de los diferentes módulos del Portal Web debe corresponder a su información y cumplir con lo establecido en los Términos y Condiciones de uso del Portal Web.
                </p>
                <p>
                    Toda la información que incluya y sea guardada en el Portal Web se presumirá por parte de WILLIS TOWERS WATSON COLOMBIA CORREDORES DE SEGUROS S.A como cierta y veraz. Por ende, en caso de falsedad o que los hechos sean inciertos, usted será el único responsable
                    de cualquier daño o perjuicio que pudiera ocasionar ya sea a WILLIS TOWERS WATSON CORREDORES DE SEGUROS S.A o a cualquier tercero que se vea afectado con la información registrada.
                </p>
                <p>
                    La información que usted suministra a WILLIS TOWERS WATSON COLOMBIA CORREDORES DE SEGUROS S.A al hacer uso del Portal Web se presume cierta y completa. Es con base en la información suministrada por usted que WILLIS TOWERS WATSON COLOMBIA CORREDORES DE
                    SEGUROS S.A realizará sus actividades y prestará sus servicios como intermediario de seguros, por lo que usted deberá garantizar que la información suministrada es confiable y cierta.
                </p>
                <div class="text-right">
                    <!-- <button class="btn btn-primary my-3" placeholder="Correo Electrónico" (click)="insertarAdminDesignado()">Acepto</button> -->
                    <button class="btn btn-primary my-3" placeholder="Correo Electrónico" (click)="insertarPersonaNatural()">Acepto</button>
                </div>

            </div>
        </div>
    </div>
</div>
<!-- /End modal PERSONA NATURAL -->

<div class="footer-cli">
    <div class="row d-flex mx-2">
        <div class="col-md-12 d-inline-flex my-3">
            <div class="flex-fill"><a>Willis Towers Watson</a></div>
            <div class="flex-fill"><a>Términos de uso | Políticas de privacidad</a></div>
            <div class="ml-auto"><a>Versión Copyright 2018, Diseñado por: Willis Towers Watson</a></div>
        </div>
    </div>
</div>